import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import avatar1 from "assets/images/users/avatar-9.png";
import { BadgeCheck, Globe, ChevronDown } from 'lucide-react';
import CountUp from 'react-countup';
import OrderDetails from "./OrderDetails";
import ManagerDetails from "./ManagerDetails";
import VendorDetails from './VendorDetails';
import { getManager, getMainAccount, getgoldsoldvalue, getGoldWeigth, getOutstanding } from 'slices/thunk';
import { RootState } from 'slices';
import logoSm from "assets/images/logo-sm.png";

const SocialMediaDashboard: React.FC = () => {
    const [selectedCountry, setSelectedCountry] = useState<string>('dubai');
    const [selectedSubLocation, setSelectedSubLocation] = useState<string | null>(null);
    const [showSaudiSubLocations, setShowSaudiSubLocations] = useState<boolean>(false);

    const dispatch = useDispatch();

    const mainAccount = useSelector((state: RootState) => state.Ecommerce.account);
    const goldSold = useSelector((state: RootState) => state.Ecommerce.goldSold);
    const goldOutstanding = useSelector((state: RootState) => state.Ecommerce.goldOutstanding);
    const manager = useSelector((state: RootState) => state.Ecommerce.Manager) as any[];

    useEffect(() => {
        dispatch(getMainAccount() as any);
        dispatch(getgoldsoldvalue() as any);
        dispatch(getGoldWeigth() as any);
        dispatch(getOutstanding() as any);
    }, [dispatch]);

    useEffect(() => {
        const locationToFetch = selectedCountry === "saudi" && selectedSubLocation
            ? selectedSubLocation
            : selectedCountry;
        dispatch(getManager(locationToFetch) as any);
    }, [dispatch, selectedCountry, selectedSubLocation]);


    const selectedManagerData = useMemo(() => {
        if (!manager || !Array.isArray(manager)) return [];
        return manager;
    }, [manager]);

    const selectedAccountData = useMemo(() => {
        if (!selectedManagerData) return [];
        return selectedManagerData.flatMap((item: any) => item.account || []);
    }, [selectedManagerData]);

    const selectedSales = useMemo(() => {
        if (!selectedManagerData) return [];
        return selectedManagerData.flatMap((item: any) => item.sales || []);
    }, [selectedManagerData]);

    const TransactionSales = useMemo(() => {
        if (!selectedManagerData) return [];
        return selectedManagerData.flatMap((item: any) => item.transaction || []);
    }, [selectedManagerData]);

    const saudiSubLocations = ["jeddah", "dammam", "riyadh"];
    const countries = ["dubai", "saudi", "qatar"];

    // peniding Payment
  const Difference = useMemo(() => {
    const total = typeof mainAccount?.data === 'number' ? mainAccount.data : parseFloat(mainAccount?.data || '0');
    const pending = typeof goldOutstanding?.data === 'number' ? goldOutstanding.data : parseFloat(goldOutstanding?.data || '0');
    return total - pending;
}, [mainAccount?.data, goldOutstanding?.data]);

    return (
        <React.Fragment>
            <div className="grid grid-cols-12 mt-5 gap-x-5">
                <div className="col-span-3 shrink-0 lg:block sticky top-[10vh]">
                    <div className="card h-[170px]">
                        <div className="card-body">
                            <div className="flex items-center gap-3 mb-5">
                                <div className="rounded-full bg-slate-100 shrink-0 dark:bg-zink-600">
                                    <img src={logoSm} alt="" className="rounded-full h-14" />
                                </div>
                                <div className="grow">
                                    <h6 className="mb-1 text-15">
                                        Admin{" "}
                                        <BadgeCheck className="inline-block size-4 text-sky-500 fill-sky-100 dark:fill-sky-500/20" />
                                    </h6>
                                    <p className="text-slate-500 dark:text-zink-200">Admin@gmail.com</p>
                                </div>
                            </div> 
                        </div>
                    </div>

                    <div className="card h-[350px] overflow-y-auto mt-4">
                        <div className="card-body">
                            <p className="text-slate-500 dark:text-zink-200 mb-4">Select The Location</p>
                            <ul className="flex flex-col w-full gap-2 mb-4 text-sm font-medium shrink-0 nav-tabs">
                                {countries.map((country) => (
                                    <React.Fragment key={country}>
                                        <li
                                            className={`group grow ${selectedCountry === country && (!selectedSubLocation || country !== 'saudi') ? 'active' : ''}`}
                                        >
                                            {country !== "saudi" ? (
                                                <Link
                                                    to="#"
                                                    onClick={() => {
                                                        setSelectedCountry(country);
                                                        setSelectedSubLocation(null);
                                                        setShowSaudiSubLocations(false);
                                                    }}
                                                    className={`inline-block px-4 w-full py-2 text-base transition-all duration-300 ease-linear rounded-md ${selectedCountry === country
                                                            ? 'bg-custom-500 text-white'
                                                            : 'text-slate-500 dark:text-zink-200'
                                                        }`}
                                                >
                                                    <Globe className="inline-block size-4 align-middle mr-1" />
                                                    <span className="align-middle uppercase">{country}</span>
                                                </Link>
                                            ) : (
                                                <button
                                                    onClick={() => {
                                                        setSelectedCountry("saudi");
                                                        setShowSaudiSubLocations(!showSaudiSubLocations);
                                                        setSelectedSubLocation(null);
                                                    }}
                                                    className={`inline-flex items-center justify-between px-4 w-full py-2 text-base transition-all duration-300 ease-linear rounded-md ${selectedCountry === "saudi" && !selectedSubLocation
                                                            ? 'bg-custom-500 text-white'
                                                            : 'text-slate-500 dark:text-zink-200'
                                                        }`}
                                                >
                                                    <span>
                                                        <Globe className="inline-block size-4 align-middle mr-1" />
                                                        <span className="align-middle uppercase">saudi</span>
                                                    </span>
                                                    <ChevronDown className={`inline-block size-4 ml-2 transition-transform ${showSaudiSubLocations ? 'rotate-180' : ''}`} />
                                                </button>
                                            )}
                                        </li>
                                        {country === "saudi" && showSaudiSubLocations && (
                                            <ul className="ml-4 flex flex-col gap-2 mt-2 uppercase">
                                                <li>
                                                    <Link
                                                        to="#"
                                                        onClick={() => {
                                                            setSelectedSubLocation(null);
                                                        }}
                                                        className={`block px-4 py-2 rounded-md ${selectedCountry === "saudi" && !selectedSubLocation
                                                                ? 'bg-custom-500 text-white'
                                                                : 'text-slate-500 dark:text-zink-200'
                                                            }`}
                                                    >
                                                        Saudi (All)
                                                    </Link>
                                                </li>
                                                {saudiSubLocations.map((city) => (
                                                    <li key={city}>
                                                        <Link
                                                            to="#"
                                                            onClick={() => {
                                                                setSelectedSubLocation(city);
                                                            }}
                                                            className={`block px-4 py-2 rounded-md ${selectedSubLocation === city
                                                                    ? 'bg-custom-500 text-white'
                                                                    : 'text-slate-500 dark:text-zink-200'
                                                                }`}
                                                        >
                                                            {city}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </React.Fragment>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Manager, Order, Vendor details */}
                <ManagerDetails manager={selectedManagerData.map((m: any) => m.manager)} account={selectedAccountData} />
                <OrderDetails manager={selectedManagerData.map((m: any) => m.manager)} sales={selectedSales} account={selectedAccountData} transaction={TransactionSales} />
                <VendorDetails manager={selectedManagerData.map((m: any) => m.manager)} sales={selectedSales} account={selectedAccountData} transaction={TransactionSales} />
            </div>
        </React.Fragment>
    );
};

export default SocialMediaDashboard;
